import { ReactNode } from "react";

type P = { children?: ReactNode; href?: string };

export const markdownComponents = {
  p: ({ children }: P) => <p className="my-1">{children}</p>,
  ul: ({ children }: P) => <ul className="my-1 ml-4 list-disc">{children}</ul>,
  ol: ({ children }: P) => <ol className="my-1 ml-4 list-decimal">{children}</ol>,
  li: ({ children }: P) => <li className="my-0.5">{children}</li>,
  strong: ({ children }: P) => <strong className="font-bold">{children}</strong>,
  em: ({ children }: P) => <em className="italic">{children}</em>,
  code: ({ children }: P) => (
    <code className="px-1 rounded bg-gray-200 font-mono text-[11px]">{children}</code>
  ),
  pre: ({ children }: P) => (
    <pre className="my-1 p-2 rounded bg-gray-200 font-mono text-[11px] overflow-x-auto">
      {children}
    </pre>
  ),
  a: ({ href, children }: P) => (
    <a href={href} target="_blank" rel="noreferrer" className="text-blue underline">
      {children}
    </a>
  ),
  h1: ({ children }: P) => <h1 className="my-1 text-sm font-bold">{children}</h1>,
  h2: ({ children }: P) => <h2 className="my-1 text-sm font-bold">{children}</h2>,
  h3: ({ children }: P) => <h3 className="my-1 text-xs font-bold">{children}</h3>,
};
